import type { Breadcrumb, Event } from '@sentry/react'
import { cleanProperties, isSensitiveAnalyticsUrl } from './productAnalytics'

export function sanitizeSentryBreadcrumb(breadcrumb: Breadcrumb): Breadcrumb | null {
  // Console arguments and DOM selectors can include displayed publish credentials.
  if (breadcrumb.category === 'console' || breadcrumb.category?.startsWith('ui.')) return null
  return cleanProperties(breadcrumb as Record<string, unknown>) as Breadcrumb
}

export function sanitizeSentryEvent<T extends Event>(event: T, currentUrl = ''): T | null {
  if ([currentUrl, event.request?.url, event.transaction]
    .some(value => typeof value === 'string' && value && isSensitiveAnalyticsUrl(value))) return null
  const result = cleanProperties(event as Record<string, unknown>) as T
  // Preserve the exception/stack and timing information, never request payloads.
  if (result.request) delete result.request.data
  if (result.breadcrumbs) result.breadcrumbs = result.breadcrumbs.flatMap(breadcrumb => {
    const clean = sanitizeSentryBreadcrumb(breadcrumb)
    return clean ? [clean] : []
  })
  return result
}
